import { render, staticRenderFns } from "./OrderStatusTab.vue?vue&type=template&id=02549ce2&"
import script from "./OrderStatusTab.vue?vue&type=script&lang=ts&"
export * from "./OrderStatusTab.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStatusTab.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports